export default __webpack_public_path__ + "static/media/the-bottles.28b7b500.jpg";